{
  "Automatic ({language})": "Automatisch ({language})",
  "Language": "Sprache",
  "Cancel": "Abbrechen",
  "OK": "OK",
  "Ok": "OK",
  "Okay": "Okay",
  "Yes": "Ja",
  "No": "Nein",
  "Save": "Speichern",
  "Saved": "Gespeichert",
  "Saving...": "Wird gespeichert...",
  "Saving…": "Wird gespeichert…",
  "Delete": "Löschen",
  "Remove": "Entfernen",
  "Edit": "Bearbeiten",
  "Change": "Ändern",
  "Close": "Schließen",
  "Done": "Fertig",
  "Back": "Zurück",
  "Next": "Weiter",
  "Continue": "Weiter",
  "Skip": "Überspringen",
  "Retry": "Wiederholen",
  "Try again": "Erneut versuchen",
  "Please try again.": "Bitte versuche es erneut.",
  "Please try again": "Bitte versuche es erneut",
  "Something went wrong": "Etwas ist schiefgelaufen",
  "Something went wrong. Please try again.": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
  "Error": "Fehler",
  "Loading...": "Wird geladen...",
  "Loading…": "Wird geladen…",
  "Share": "Teilen",
  "Copy": "Kopieren",
  "Copy link": "Link kopieren",
  "Copied": "Kopiert",
  "Copied!": "Kopiert!",
  "Link copied": "Link kopiert",
  "Open": "Öffnen",
  "Restore": "Wiederherstellen",
  "Learn more": "Mehr erfahren",
  "More": "Mehr",
  "Help": "Hilfe",
  "Settings": "Einstellungen",
  "Open Settings": "Einstellungen öffnen",
  "Profile": "Profil",
  "Email": "E-Mail",
  "Password": "Passwort",
  "Name": "Name",
  "Title": "Titel",
  "Location": "Ort",
  "Date and time": "Datum und Uhrzeit",
  "Privacy": "Datenschutz",
  "Embed": "Embed",
  "Branding": "Branding",
  "Logo": "Logo",
  "Guestbook": "Gästebuch",
  "Fundraising": "Spendenaktion",
  "Pricing": "Preise",
  "Plans": "Pläne",
  "EventLive Plans": "EventLive-Pläne",
  "My Events": "Meine Events",
  "Event link": "Event-Link",
  "Event title": "Eventtitel",
  "Go Live": "Live gehen",
  "Watch Live": "Live ansehen",
  "Live only": "Nur live",
  "Start free test": "Kostenlosen Test starten",
  "Free test": "Kostenloser Test",
  "Unlock event": "Event freischalten",
  "Unlock": "Freischalten",
  "Sell Tickets": "Tickets verkaufen",
  "Video Wall": "Videowand",
  "Manage Video": "Video verwalten",
  "Upload video": "Video hochladen",
  "What's new": "Neuigkeiten",
  "What's New": "Neuigkeiten",
  "Camera": "Kamera",
  "Required": "Erforderlich",
  "Terms": "Nutzungsbedingungen",
  "Monthly": "Monatlich",
  "Unlimited": "Unbegrenzt",
  "Not found": "Nicht gefunden",
  "Not signed in": "Nicht angemeldet",
  "Please sign in again.": "Bitte melde dich erneut an.",
  "Too many requests. Please wait a moment and try again.": "Zu viele Anfragen. Bitte warte einen Moment und versuche es dann erneut.",
  "Welcome to EventLive": "Willkommen bei EventLive",
  "Today": "Heute",
  "Tomorrow": "Morgen",
  "Yesterday": "Gestern",
  "MMM D, YYYY": "D. MMM YYYY",
  "MMM D": "D. MMM",
  "h:mm A": "HH:mm",
  "h:mm a": "HH:mm",
  "Test Event": "Test-Event"
}
